import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_down_orange",
  "use": "icon-icon_arrow_down_orange-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_down_orange\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"#F14B35\" fill-rule=\"nonzero\" d=\"M8 8.428 11.636 5 13 6.286 8 11 3 6.286 4.364 5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol